<template>
  <div>
    <div
      class="grid sm:grid-cols-1 md:grid-cols-"
    >
      <div class="panel">
        <div class="panel-body">
          <ok-discard-weekly :data="totals_weekly" />
        </div>
      </div>
      <div class="panel">
        <div class="panel-body">
          <crop-size-packages-by-weeks :data="crop_size_packages_by_weeks" />
        </div>
      </div>
      <WeeklyTable :agro_exporter_id="agro_exporter_id" :agro_exporter_process_id="agro_exporter_process_id" />
    </div>
  </div>
</template>

<script>
import WeeklyTable from "@/components/views/agro_exporter/production/query_by_provider/charts/WeeklyTable.vue"
import OkDiscardWeekly from "@/components/views/agro_exporter/production/query_by_provider/charts/OkDiscardWeekly.vue";
import CropSizePackagesByWeeks from "@/components/views/agro_exporter/production/query_by_provider/charts/CropSizePackagesByWeeks.vue";
export default {
  name: "AEProductionQueryProvidersShowProcessWeekly",
  components: {
    OkDiscardWeekly,
    WeeklyTable,
    CropSizePackagesByWeeks
  },
  data() {
    return {
      seriesM: this.discarded_motives
    };
  },
  props: {
    agro_exporter_id: { required: true },
    agro_exporter_process_id: { required: true },
    totals_weekly: { required: true },
    crop_size_packages_by_weeks: { required: true }
  },
  created() {
  },
  computed: {
  }
};
</script>
